/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRefreshApp = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m11 22-9-5.5V6.4L11 2l9 4.4V11h-2V8.7l-6 3.4v7l.7-.4 1.1 1.7zm-7-6.6 6 3.7v-7L4 8.8zm1.2-8.3 5.8 3.3 5.9-3.3L11 4.2zM18 22c-2.2 0-4-1.8-4-3.9 0-2.2 1.8-4.1 4-4.1h.1l-.6-.6 1.4-1.4 3 3-2.9 3.1-1.4-1.4.6-.7H18c-1.1 0-2 1-2 2.1s.9 1.9 2 1.9 2-.9 2-1.9l2-.1c0 2.3-1.8 4-4 4z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgRefreshApp as RefreshApp };
